export const FILTER_ATTR_CHANGE = 'FILTER_ATTR_CHANGE';
export const FILTER_ATTR_BULK_APPLY = 'FILTER_ATTR_BULK_APPLY';

interface ChangeFilterAttribute
{
    type: typeof FILTER_ATTR_CHANGE,
    name: string,
    value: any,
    isChecked?: boolean
}

interface ApplyBoardFilters
{
    type: typeof FILTER_ATTR_BULK_APPLY,
    payload: Record<string, any>
}

export type FilterActionTypes = ChangeFilterAttribute | ApplyBoardFilters;